const tagService = require('../../services/tag/tagService')

const state = {
  tags: [],
}

const getters = {
  tags: (state) => state.tags,
}

const actions = {
  async fetchTags({ commit, dispatch }) {
    commit('setIsLoading', true)

    tagService.list()
      .then(({ data }) => {
        commit('setTags', data)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', errorMessages(data.errors))
        : dispatch('showErrorMessage', data.message)
      })
      .finally(() => commit('setIsLoading', false))
  }
}

const mutations = {
  setTags: (state, tags) => {
    state.tags = tags
  }
}

export default {
  state,
  mutations,
  actions,
  getters,
}